import { CommitmentsData } from './../commitments.data';
import { ServicesData } from './../../services/services.data';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, EventEmitter, Output, Inject } from '@angular/core';
import { ClosedCommitmentMdl } from './commitment';

@Component({
    selector: 'commitment-closed-dlg',
    templateUrl: './commitment-closed-dlg.tmpl.html'
})

export class CommitmentClosedDlg {

    constructor(
        public dialogRef: MatDialogRef<CommitmentClosedDlg>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        public servicesData: ServicesData,
        private commitmentsData: CommitmentsData
    ) { }

    public formData: FormGroup;
    closedDetails: ClosedCommitmentMdl;



    ngOnInit(): void {
        this.initForm();
        this.loadClosedDetails();
    }

    loadClosedDetails() {
        this.commitmentsData.getCommitmentClosedDetails(this.data.commitmentID)
            .subscribe((c: ClosedCommitmentMdl) => {
                this.closedDetails = c;
                this.formData.patchValue(c);
            });
    }

    validateDate = c => {
        // tslint:disable-next-line:max-line-length
        if (this.formData != null && this.formData.controls.closedStatus.value != ""
            && this.formData.controls.closedStatus.value != null && (!c.value || c.value === 'undefined')) {
            return { required: true };
        }
        return null;
    };
    validateStatus = c => {
        // tslint:disable-next-line:max-line-length
        if (this.formData != null && this.formData.controls.closedDate.value != ""
            && this.formData.controls.closedDate.value != null && (!c.value || c.value === 'undefined')) {
            return { required: true };
        }
        return null;
    };

    formValidation = frm => {
        // tslint:disable-next-line:max-line-length
        if (frm
            &&
            (this.formData.controls.closedDate.value && this.formData.controls.closedStatus.value)
            ||
            (!this.formData.controls.closedDate.value && !this.formData.controls.closedStatus.value)
        ) {
            return null;
        }
        return { required: true };
    };
 

    private initForm(): void {
        this.formData = this.formBuilder.group({
            commitmentID: [, Validators.required],
            closedComment: [],
            closedDate: [null, this.validateDate],
            closedStatus: [null, this.validateStatus]
        });
        this.formData.setValidators(this.formValidation);
    }

    public isValid(): boolean {
        return (this.formData && this.formData.valid);
    }
}



